/** Whether a notification `link` points off-site (e.g. the casino's own domain, not one of
 * core's own routes) — Next.js client-side routing (`router.push`) can't navigate to a
 * cross-origin URL, so callers need to fall back to a full page navigation for these. */
export function isExternalLink(link: string): boolean {
  return link.startsWith('http://') || link.startsWith('https://')
}
